var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    transform: "translate(2.5, 4)",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,8 L9,8 M9,8 L9,24 M9,24 L3,24 M3,24 L3,8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,5.5 L21,5.5",
    id: "Path-38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,9.5 L21,9.5",
    id: "Path-38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,13.5 L21,13.5",
    id: "Path-38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,1 L25.5,1 M25.5,1 L25.5,24 M25.5,24 L9,24 M9,24 L9,1",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/companies.53f546a5fa6f30208af9b8b5a37d4db2.svg";
export { ForwardRef as ReactComponent };